import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to track navigation events and prevent session clearing during internal navigation
 * This hook sets a flag in sessionStorage and a global variable to indicate that navigation is happening within the app
 */
export const useNavigationTracking = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('Navigation tracking: Route changed to', location.pathname);
    // Set a flag to indicate we're navigating within the app
    sessionStorage.setItem('navigatingWithinApp', 'true');
    window.isNavigatingWithinApp = true;
    console.log('Navigation tracking: Set navigatingWithinApp flag to true');
    
    // Clear the flag after a short delay
    const timer = setTimeout(() => {
      sessionStorage.removeItem('navigatingWithinApp');
      window.isNavigatingWithinApp = false;
      console.log('Navigation tracking: Removed navigatingWithinApp flag');
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [location.pathname]);

  return null;
}; 